import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export type MarketingDocumentFormat = "docx" | "pdf";

export class MarketingDocument extends HasProjectMixin(Model) {

  declare id: number;
  declare board: number;
  declare workFile: number | null;
  declare format: MarketingDocumentFormat;
  declare title: string;
  declare filename: string;
  declare file: number | null;
  declare fileId: number | null;
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number | null;
  declare updater: number | null;

  static get $name() {
    return "MarketingDocument";
  }

  static get fields() {
    return [
      "id",
      "board",
      { name: "workFile", dataSource: "work_file", type: "number" },
      "format",
      "title",
      "filename",
      { name: "file", type: "number" },
      { name: "fileId", dataSource: "file_id", type: "number" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "creator", type: "number" },
      { name: "updater", type: "number" },
    ];
  }

  get displayTitle(): string {
    return this.title?.trim() || this.filename?.trim() || "Untitled document";
  }
}

// @ts-expect-error - exposeProperties is internal method
MarketingDocument.exposeProperties();
